module.exports = __webpack_public_path__ + "static/2-676422d9c34d93c37674a2f636ae60b8.wav";